export default {
  rules: ['Type', 'Sponsoring Product, UPC', 'Bonus Product, UPC', 'Bonus Amount', '']
}
